import Rails from "@rails/ujs"
import 'bootstrap';
import '../controllers/index.js';
import 'chartkick/highcharts';
import jquery from 'jquery';
import jstz from 'jstz';
import Turbolinks from 'turbolinks';
import '../account/index.js';
import '../clean_admin/index.js';

// Make jQuery available as a global for inline scripts in views.
globalThis.$ = jquery;
globalThis.jQuery = jquery;

// For inline use in `app/views/account/onboarding/user_details/edit.html.erb`.
globalThis.jstz = jstz;

Rails.start();
Turbolinks.start();
